import { useTokens } from '../shared/theme';
import CupMark from '../shared/CupMark';
import InstitutionMark from '../shared/InstitutionMark.jsx';
import { marketingHomeUrl } from './portalUrl.js';

/**
 * Split-screen shell for the portal sign-in (2026-07-21): mirrors the main
 * app's unified auth page — lockup top-left (school mark beside it when
 * branded), content column on the left, and the campus-green painting in a
 * rounded card on the right at desktop, with the program-insight caption.
 * Progress/error states swap the left column in place so the painting never
 * moves. Pre-shell states other than sign-in keep using StateScreen.
 */
export default function AuthScreen({ children, institution }) {
  const t = useTokens();
  const schoolName = institution?.branding?.displayName || institution?.name;
  return (
    <div
      className="min-h-screen w-full flex"
      style={{ backgroundColor: t.page, color: t.body, fontFamily: t.fonts.body }}
    >
      <div className="flex min-h-screen min-w-0 flex-1 flex-col">
        <div className="flex items-center justify-between gap-5 px-8 pt-8">
          <a
            href={marketingHomeUrl()}
            aria-label="Coffee Chats home"
            className={`shrink-0 rounded-lg focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 ${t.focusRing}`}
          >
            {/* Full lockup at every width, sized to match the student login
                page's logo bar (34px cup, 22px wordmark) so the two sign-in
                pages read at the same scale. */}
            <CupMark size={34} wordmarkSize={22} withWordmark />
          </a>
          {institution ? (
            <InstitutionMark
              name={schoolName}
              slug={institution.slug}
              logoFileId={institution.branding?.logoFileId}
              logoSource={institution.branding?.logoSource}
              autoLogoDomain={institution.branding?.autoLogoDomain}
              size={42}
              showName
            />
          ) : null}
        </div>
        <div className="flex w-full flex-1 flex-col justify-center px-8 pb-16">
          <div className="mx-auto w-full max-w-[460px]">{children}</div>
        </div>
      </div>

      <div className="hidden p-6 lg:block lg:w-1/2 lg:flex-none">
        <div
          className="relative h-full min-h-[560px] overflow-hidden rounded-3xl"
          style={{ backgroundColor: t.surface }}
        >
          <img
            src="/hero-campus.webp"
            alt="A campus green at golden hour"
            className="absolute inset-0 h-full w-full object-cover"
          />
        </div>
      </div>
    </div>
  );
}
